import { useUser } from "@clerk/react";
import { resolveRole } from "@/utils/roles";
import AccountDropdown from "@/components/account-dropdown";
import { adminNavItems, navItems } from "@/config/nagivation/desktop-routes-config";
import { Button, Drawer } from "@heroui/react";
import { useLocation, useNavigate } from "react-router-dom";

const MobileMenuDrawer = ({ state }) => {
  const { user } = useUser();
  const isAdmin = resolveRole(user) === "admin";
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavigate = (route) => {
    navigate(route);
    state.close();
  };

  const renderNavItems = (items) =>
    items.map((item) => {
      const Icon = item.icon;
      const isActive = item.route === location.pathname;

      return (
        <Button
          key={item.key}
          variant={isActive ? "primary" : "ghost"}
          onPress={() => handleNavigate(item.route)}
          className="gap-4 justify-start h-10 rounded-2xl"
          fullWidth
        >
          <Icon />
          <span>{item.label}</span>
        </Button>
      );
    });

  return (
    <Drawer state={state}>
      <Drawer.Backdrop variant="blur">
        <Drawer.Content placement="left" className="w-[260px]">
          <Drawer.Dialog className="bg-background h-full">
            <Drawer.Header className="flex-row items-center gap-2">
              <img src="/fav.png" width={40} alt="" />
              <span className="font-extrabold text-lg">Loopp</span>
            </Drawer.Header>

            <Drawer.Body className="flex flex-col gap-4 px-4">
              <div className="flex flex-col items-start w-full">{renderNavItems(navItems)}</div>

              <div className="h-px bg-separator w-full" />

              {isAdmin && <span className="text-[10px] text-muted uppercase font-semibold">Admin Routes</span>}

              <div className="flex flex-col items-start w-full">{isAdmin && renderNavItems(adminNavItems)}</div>
            </Drawer.Body>

            <Drawer.Footer className="px-4 pb-4">
              <AccountDropdown />
            </Drawer.Footer>
          </Drawer.Dialog>
        </Drawer.Content>
      </Drawer.Backdrop>
    </Drawer>
  );
};

export default MobileMenuDrawer;